export default __webpack_public_path__ + "static/HomeBG3-b85e9f6034a3a93080ed13c490e01fbf.png";